import * as VKID from '@vkid/sdk';

const API = import.meta.env.DEV ? '/api' : 'https://api.yumnote.ru';
const REDIRECT = 'https://yumnote.ru/auth/vk/callback';
const LOGIN_STATE = 'yumnote.vk.login.v1';
const random = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), x => x.toString(16).padStart(2, '0')).join('');

export async function startVkLogin() {
  const state = random(); const verifier = random();
  sessionStorage.setItem(LOGIN_STATE, JSON.stringify({ state, verifier, createdAt: Date.now() }));
  VKID.Config.init({ app: 54874790, redirectUrl: REDIRECT, state, codeVerifier: verifier, scope: '', mode: VKID.ConfigAuthMode.Redirect });
  await VKID.Auth.login();
}

export async function finishVkLogin(): Promise<string | null> {
  if (location.pathname !== '/auth/vk/callback') return null;
  const params = new URLSearchParams(location.search);
  const code = params.get('code'); const deviceId = params.get('device_id'); const state = params.get('state');
  // Remove the one-time code from history immediately, including on errors.
  history.replaceState(null, '', '/');
  const raw = sessionStorage.getItem(LOGIN_STATE); sessionStorage.removeItem(LOGIN_STATE);
  let pending: { state?: unknown; verifier?: unknown; createdAt?: unknown };
  try { pending = JSON.parse(raw ?? '{}') as typeof pending; } catch { throw new Error('Сеанс входа устарел. Попробуйте снова.'); }
  if (!code || !deviceId || !state || state !== pending.state || typeof pending.verifier !== 'string' || typeof pending.createdAt !== 'number' || Date.now() - pending.createdAt > 10 * 60 * 1000 || pending.createdAt > Date.now()) throw new Error('Сеанс входа устарел. Попробуйте снова.');
  const response = await fetch(`${API}/v1/account/vk`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code, deviceId, state, verifier: pending.verifier }) });
  if (!response.ok) throw new Error('Не удалось войти через VK. Попробуйте снова.');
  const data: unknown = await response.json();
  if (!data || typeof data !== 'object' || !('userId' in data) || typeof data.userId !== 'string') throw new Error('Не удалось проверить аккаунт.');
  return data.userId;
}

export async function currentAccount(): Promise<string | null> {
  const response = await fetch(`${API}/v1/account/session`, { credentials: 'include' });
  if (response.status === 401) return null;
  if (!response.ok) throw new Error('Сервер аккаунтов недоступен.');
  const data: unknown = await response.json();
  if (!data || typeof data !== 'object' || !('userId' in data) || typeof data.userId !== 'string') throw new Error('Не удалось проверить аккаунт.');
  return data.userId;
}
export async function logoutAccount(): Promise<void> {
  const response = await fetch(`${API}/v1/account/logout`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: '{}' });
  if (!response.ok && response.status !== 401) throw new Error('Не удалось выйти.');
}
